module.exports = __webpack_public_path__ + "media/shortLineSnipe.07f23a5d.mp4";